// 應用進入點：組裝 Pinia、路由與 TanStack Query，然後掛載
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'

// 樣式必須最先匯入：Tailwind 的 preflight 與 tokens 要在任何元件樣式之前進入 cascade，
// 否則元件的 utility 會被 preflight 覆蓋，開發模式下會看到樣式閃爍
import '@/styles/main.css'

import App from '@/App.vue'
import router from '@/app/router'
import { createQueryClient } from '@/app/providers/query'
import { runtimeConfig } from '@/api/runtime-config'

/*
 * ★ QueryClient 由 `app/providers/query.createQueryClient()` 建立：快取分層、retry 策略與
 *   全域 MutationCache（後端 403 toast）全部集中在那裡。之前這裡另抄一份 defaultOptions，
 *   等於有兩個事實來源 —— 改了 providers 的 staleTime 而 app 沒有跟隨，是看不出來的。
 */
const queryClient = createQueryClient()

// 標題走執行期設定，讓同一份 dist/ 能掛在不同品牌下
if (runtimeConfig.title) {
  document.title = `${runtimeConfig.title} 商戶後台`
}

createApp(App).use(createPinia()).use(router).use(VueQueryPlugin, { queryClient }).mount('#app')
